import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { StoreSlider, TimingAccordion, StoreMisc, RoutesList } from './storeSidebar';
import { GoogleMap, DirectionsRenderer } from '@react-google-maps/api';
import { Rating, List, ListItem, ListItemText, ListItemAvatar, Typography, Button, Pagination, Grid, Box } from '@mui/material/';
import { Storedirected, googlemapcenteraction, InfoBoxAction, MapZoomAction, paginationAction } from './actions';
import * as geolib from 'geolib';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const Sidebar = () => {
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel) => ( isExpanded ) => {
        setExpanded(isExpanded ? panel : false);
    };
    var coorinatesData = useSelector(state => state.MapCenterPoint)
    var center = coorinatesData.coordinates;
    var SiteData = useSelector(state => state.SiteData);
    var dispatch = useDispatch();
    const radius = useSelector(state => state.MadRadius);
    function backtostores() {
        dispatch(Storedirected(false))
    }
    const openInfoBox = ( data ) => {
        for ( let element of document.getElementsByClassName('rslInfobox') ) {
            element.style.display="none";
        }
        dispatch(googlemapcenteraction( { init: false, coordinates: { lat: parseFloat(data.metadata.latitude), lng: parseFloat(data.metadata.longitude) } } ));
        dispatch(MapZoomAction(20));
        dispatch(InfoBoxAction(data));
        var id = `infobox_${data.id}`;
        setTimeout(function() {
            if ( null !== document.getElementById(id) ) {
                document.getElementById(id).style.display = "block";
            }
        }, 1000);
        window.scrollTo({ top: 0, behavior: "smooth"});
    }
    var dlatitude = SiteData.dlatitude ? parseFloat(SiteData.dlatitude) : 48.8584;
    var dlongitude = SiteData.dlongitude ? parseFloat(SiteData.dlongitude) : 2.2945;
    var hidepagination = SiteData.hidepagination;
    var paginationinc = parseInt(useSelector(state => state.paginationOffset));
    if ( 0 === center.lng ) {
        center = {lat:dlatitude, lng: dlongitude};
    }
    const LocationsData = useSelector(state => state.StoreLocations);
    const Locations = LocationsData.data;
    var Storeclicked = useSelector(state => state.Storeclicked);
    const titleColor = SiteData.sidebar_stores_title_color ? SiteData.sidebar_stores_title_color : '#000';
    if (Storeclicked.clicked) {
        const singleStoreClass = ('bottom-grid' === SiteData.sidebarposition) ? 'rslSingleStore' : '';
        return(
            <List className={singleStoreClass} sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                <ArrowBackIcon className="rsl_backtostores" onClick={() => backtostores()} />
                {(!SiteData.hidegallery) ? <StoreSlider /> : ''}
                {(!SiteData.hidetiming) ? <TimingAccordion /> : ''}
                <StoreMisc />
                {(!SiteData.hidesteps) ? <RoutesList /> : ''}
            </List>
        )
    } else if (undefined !== Locations ) {
        var isyes = false;
        var latitude = 0;
        var longitude = 0;
        var storeCounter = 0;
        var thumbnail = false;
        const directionBtnColor = SiteData.direction_btn_color ? SiteData.direction_btn_color : '#efefef';
        const directionBtnTextColor = SiteData.direction_btn_text_color ? SiteData.direction_btn_text_color : '#000';
        const websiteBtnColor = SiteData.website_btn_color ? SiteData.website_btn_color : '#ccc';
        const websiteBtnTextColor = SiteData.website_btn_text_color ? SiteData.website_btn_text_color : '#000';
        const accordionClass = ('bottom-grid' === SiteData.sidebarposition) ? 'rslGridStore rslStoresAccordion' : 'rslStoresAccordion';
        const totalStoresLabel = SiteData.totalStoresLabel ? SiteData.totalStoresLabel : 'Total Stores';
        if ( SiteData.enableAccordion ) {
        return (<div className={accordionClass}>
            {Locations.map((location, index) => {
                longitude = parseFloat(location.metadata.longitude);
                latitude = parseFloat(location.metadata.latitude);
                isyes = geolib.isPointWithinRadius(
                    { latitude: latitude, longitude: longitude },
                    { latitude: center.lat, longitude: center.lng },//current
                    radius
                );
                if ( !isyes ) {
                    return '';
                }
                storeCounter++;
                thumbnail = location.metadata.thumbnail;
                var mdSize = 8;
                if ( !thumbnail ) {
                    mdSize = 12;
                }
                return (
                <div className="rslAllStoresAccordion" key={index}><Accordion expanded={expanded === `panel${storeCounter}`} onChange={handleChange(`panel${storeCounter}`)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                        <Typography style={{color:titleColor, margin:'1px'}}>{location.title.rendered}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={mdSize}>
                                    {!SiteData.hiderating ?
                                    <Rating name="half-rating" value={location.metadata.rating ? parseFloat(location.metadata.rating) : 0}
                                    size="small" readOnly precision={0.5} /> : ''}
                                    {!SiteData.hidesidebarphone ? <p className="rsl_store_phone">{location.metadata.phone}</p> : ''}
                                    {!SiteData.hidesidebaraddress ? <p>{location.metadata.fulladdress}</p> : ''}
                                    {!SiteData.hidesidebaremail ? <p className="rsl_store_email">{location.metadata.email}</p> : ''}
                                </Grid>
                                {(thumbnail && !SiteData.hidesidebarthumbnail) ? 
                                <Grid item xs={12} md={4}>
                                    <ListItemAvatar>
                                        <img alt="store" width="100" src={thumbnail} />
                                    </ListItemAvatar> 
                                </Grid> : ''}
                                <Grid item xs={12} md={12}>
                                    <span className="rslSidebarButtons">
                                        <Button style={{background:directionBtnColor, color:directionBtnTextColor, marginRight:'10px'}} onClick={ () => {openInfoBox(location)}}>{SiteData.label_direction_btn ? SiteData.label_direction_btn : 'Direction'}</Button>
                                        {location.metadata.website ? <a className="rslStoreWebsiteBtn" style={{background:websiteBtnColor, color:websiteBtnTextColor}} href={location.metadata.website}>{SiteData.label_website ? SiteData.label_website : 'Website'}</a> : ''}
                                    </span>
                                </Grid>
                            </Grid>
                        </Box>
                    </AccordionDetails>
                </Accordion></div>
                );
                })}
                {(!Storeclicked.clicked && !hidepagination) ? <Pagination count={ LocationsData.totalPages ? parseInt(LocationsData.totalPages) : 0 } hidePrevButton hideNextButton defaultPage={ 1 } variant="outlined" color="secondary" onClick={e => dispatch(paginationAction(e.target.textContent ? e.target.textContent : parseInt(paginationinc)))} /> : ''}
                {!storeCounter ? <p>{SiteData.label_no_store ? SiteData.label_no_store : 'No store found'}</p> : ''}
          </div>
          );
        } else {
        return <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            <ListItem>
                {`${totalStoresLabel} ${Locations.length}`}
            </ListItem>
            {Locations.map((location, index) => {
                longitude = parseFloat(location.metadata.longitude);
                latitude = parseFloat(location.metadata.latitude);
                isyes = geolib.isPointWithinRadius(
                    { latitude: latitude, longitude: longitude },
                    { latitude: center.lat, longitude: center.lng },//current
                    radius
                );
                if ( !isyes ) {
                    return '';
                }
                storeCounter++;
                return (
                    <ListItem key={index} alignItems="flex-start">
                        <ListItemText style={{color:titleColor, margin:'1px'}} primary={ location.title.rendered }
                            secondary={
                            <React.Fragment>
                                {!SiteData.hiderating ?
                                <Rating name="half-rating" value={location.metadata.rating ? parseFloat(location.metadata.rating) : 0}
                                size="small" readOnly precision={0.5} /> : ''}
                                {!SiteData.hidesidebarphone ? <span className="rsl_store_phone" style={{display:'block'}}>{location.metadata.phone}</span> : ''}
                                {!SiteData.hidesidebaraddress ? <span style={{display:'block'}}>{location.metadata.fulladdress}</span> : ''}
                                {!SiteData.hidesidebaremail ? <span className="rsl_store_email" style={{display:'block'}}>{location.metadata.email}</span> : ''}
                                <span className="rslSidebarButtons">
                                    <Button style={{background:directionBtnColor, color:directionBtnTextColor, marginRight:'10px'}} onClick={ () => {openInfoBox(location)}}>{SiteData.label_direction_btn ? SiteData.label_direction_btn : 'Direction'}</Button>
                                    {location.metadata.website ? <a className="singleStoreWebsiteBtn" style={{background:websiteBtnColor, color:websiteBtnTextColor, padding:'9px', borderRadius: '4px', textDecoration:'none', fontWeight:'500'}} href={location.metadata.website}>{SiteData.label_website ? SiteData.label_website : 'Website'}</a> : ''}
                                </span>
                            </React.Fragment>
                        } />
                        {(!SiteData.hidesidebarthumbnail && location.metadata.thumbnail) ? <ListItemAvatar>
                            <img className="rsl_store_image" alt="store" width="100" src={location.metadata.thumbnail} />
                        </ListItemAvatar> : ''}
                    </ListItem>
                );
            })}
            {(!Storeclicked.clicked && !hidepagination) ? <Pagination count={ LocationsData.totalPages ? parseInt(LocationsData.totalPages) : 0 } hidePrevButton hideNextButton defaultPage={ 1 } variant="outlined" color="secondary" onClick={e => dispatch(paginationAction(e.target.textContent ? e.target.textContent : parseInt(paginationinc)))} /> : ''}
            {!storeCounter ? <p>{SiteData.label_no_store ? SiteData.label_no_store : 'No store found'}</p> : ''}
            </List>
            }
        }
    }
    const RMap = () => {
        var SiteData = useSelector(state => state.SiteData);
        var styles = SiteData.map_style ? JSON.parse(SiteData.map_style) : '';
        var coorinatesData = useSelector(state => state.MapCenterPoint);
        var map_type = SiteData.map_type ? SiteData.map_type : 'roadmap';
        var center = coorinatesData.coordinates;
        var directionData = useSelector(state => state.MapDirectionData);
        var streetviewcontrol = SiteData.streetviewcontrol ? true : false;
        var maptypecontrol = SiteData.maptypecontrol ? true : false;
        var zoomcontrol = SiteData.zoomcontrol ? true : false;
        var fullscreencontrol = SiteData.fullscreencontrol ? true : false;
        return(
            <div className="rsl_googlemap">
                <GoogleMap center={center} setZoom={20} zoom={SiteData.zoomqty ? parseInt(SiteData.zoomqty) : 10} mapContainerStyle={{ width: '100%', height: '100%' }}
                options={{ zoomControl: zoomcontrol, streetViewControl: streetviewcontrol, mapTypeControl: maptypecontrol, fullscreenControl: fullscreencontrol, styles: styles, mapTypeId: map_type }}>
                {directionData &&(<DirectionsRenderer directions={directionData} />)}</GoogleMap>
            </div>
        )
    }
export { Sidebar, RMap }